import React, { Suspense,useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Dashboard/Dashboard.css";


import { Button } from "reactstrap";

import Loading from "../../components/Loading";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import Footer from "../../DefaultLayout/Footer";
import NavbarSection from "../../DefaultLayout/Navbar";
import Header from "../../DefaultLayout/Header";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import { confirmRequestUser } from "../../actions/appliedPropertyAcion";
import { toast } from "react-toastify";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar";
import {
 
  CircularProgress,
} from "@mui/material";

const Index = (props) => {
  const { frontLabelsName } = props.label;
  const history = useHistory();
  const { token, id } = useParams();
  const isAuth = props.auth.isAuthenticated;
  const[disableSubmitButton,setDisableSubmitButton]=useState(false)


  const acceptHandler = () => {
    setDisableSubmitButton(true)
    let data = {
      applied_id: id,
      token: token,
      status: 1,
    };
    props
      .confirmRequestUser(data)
      .then((res) => {
        setDisableSubmitButton(false)
        history.push("/property-success");
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == res.data.message).length > 0
              ? frontLabelsName.filter((e) => e.key == res.data.message)[0][
                  "value"
                ] || res.data.message
              : res.data.message
            : res.data.message
        );
      })
      .catch((err) => {
        setDisableSubmitButton(false)
        toast.error(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == err.response.data.message)
                .length > 0
              ? frontLabelsName.filter((e) => e.key == err.response.data.message)[0][
                  "value"
                ] || err.response.data.message
              : err.response.data.message
            : err.response.data.message
        );
      });
  };

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
      {isAuth ? <LoggedHeader /> : <Header />}
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className=" mb-5 pt-5">
        <div
          className="row"
          style={{ display: "flex", justifyContent: "center",width:"100%" }}
        >
          <div className="col-lg-7 col-md-10 col-11 ">
            <div className="register-non-user11 register-body">
              <h6>
                {frontLabelsName
                  ? frontLabelsName.filter(
                      (e) => e.key == "lbl_we_are_happy_onboard"
                    ).length > 0
                    ? frontLabelsName.filter(
                        (e) => e.key == "lbl_we_are_happy_onboard"
                      )[0]["value"] || "lbl_we_are_happy_onboard"
                    : "lbl_we_are_happy_onboard"
                  : "lbl_we_are_happy_onboard"}
              </h6>
              <h6>
                {frontLabelsName
                  ? frontLabelsName.filter(
                      (e) => e.key == "lbl_rental_agreement_message"
                    ).length > 0
                    ? frontLabelsName.filter(
                        (e) => e.key == "lbl_rental_agreement_message"
                      )[0]["value"] || "lbl_rental_agreement_message"
                    : "lbl_rental_agreement_message"
                  : "lbl_rental_agreement_message"}
              </h6>
              {/* <div className="otp-box-rg-new-non11"> */}
              <div className=" d-flex justify-content-around mt-5">
                <Button disabled={disableSubmitButton} onClick={acceptHandler} className="button-get-access" style={{display:"flex",justifyContent:"center",alignItems:"center",height:"50px",minWidth:"145px"}}>
                  {" "}
                  {disableSubmitButton ? (
                        <CircularProgress
                          size={24}
                          sx={{
                            ":hover": { color: "#000" },

                            color: "#000",
                           
                          }}
                        />
                      ) :frontLabelsName
                    ? frontLabelsName.filter((e) => e.key == "lbl_accept").length > 0
                      ? frontLabelsName.filter((e) => e.key == "lbl_accept")[0][
                          "value"
                        ] || "lbl_accept"
                      : "lbl_accept"
                    : "lbl_accept"}
                </Button>
                {/* <Button>Reject</Button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  label: state.language,
  auth: state.auth,
});

export default connect(mapStateToProps, { confirmRequestUser })(Index);
